export default __webpack_public_path__ + "static/media/politique.bec49ff3.jpeg";